import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { CoverageFilter } from '@components/Product/Coverage/CoverageFilter';
import { CoverageTable } from '@components/Product/Coverage/CoverageTable';
import { productApi } from '@reducers/product/product';

export const Coverage = () => (
  <Row>
    <Col md={3}>
      <CoverageFilter />
    </Col>
    <Col md={9}>
      <CoverageTable useData={productApi.useGetCoverageQuery} />
    </Col>
  </Row>
);
